var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.coverImageUrl)?_c('section',[_c('div',{staticClass:"artist-promo-wrapper"},[_c('div',{staticClass:"artist-promo",style:({backgroundImage: ("url(" + _vm.coverImageUrl + ")")})})])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }